import axios from '../../../../api/axios';
import React,{useState,useEffect} from 'react'
import Swal from 'sweetalert2';
import {useParams,useNavigate} from 'react-router-dom'
import { useAuth } from '../../../../ContextApp/AuthContext';

function Update(){
    const {user}=useAuth()
    const [enseignants,setEnseignants]=useState([])
   
    const {id}=useParams()
    const navigate=useNavigate()
    const [my_enseignant,setMy_enseignant]=useState()
    const [enseignant,setEnseignant]=useState()
    
    useEffect(()=>{
        handleenseigner()
        handlerequestEnseignant()
       
    },[])
   const handlerequestEnseignant=async()=>{
    await axios.post('api/getenseignants',{idecole:user?.ecole?.id}).then(
        (res)=>{
            setEnseignants(res.data.items)
        }
    ).catch((err)=>{

    })
   }
   const handleenseigner=async()=>{
        await axios.post("api/getcourenseigne",{idcours:id}).then((res)=>{
           setMy_enseignant(res.data.cour)
        }).catch((err)=>{

        })
   }
   const handleclick=async()=>{
        await axios.put(`api/Coursenseigne/${id}`,{enseignant:my_enseignant}).then((res)=>{
            if(res.data.code==200){
                Swal.fire({
                    title:"Mis à jour",
                    text:"Modification de l'enseignant du cours effectuée avec succès",
                    icon:"success"
                }).then(
                    navigate("/Cours")
                )
            }
            else{
                Swal.fire({
                    title:"Mis à jour",
                    text:"Une erreur est survenue sur le serveur, le cour a été introuvable",
                    icon:"error"
                })
            }
          
        }).catch((err)=>{

        })
   }
   function confirmSave(){
        Swal.fire({
            title:"Mise à jour",
            text:"Voulez-vous vraiment modifier l'enseignant de ce cours ?",
            icon:"question",
            showCancelButton:true,
            showConfirmButton:true,
            confirmButtonText:"Confirmer",
            confirmButtonColor:"green",
            cancelButtonColor:"red"
        }).then((res)=>{
            if(res.isConfirmed){
                handleclick()
            }
        })
   }
    return(
    <>
    <div className="container py-4">
        <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
                {/* Carte au design épuré */}
                <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                    <div className="card-body p-4 p-md-5">
                        
                        {/* En-tête avec Icône */}
                        <div className="text-center mb-4">
                            <div className="bg-success bg-opacity-10 text-success rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '60px', height: '60px'}}>
                                <i className="bi bi-person-badge fs-2"></i>
                            </div>
                            <h4 className="fw-bold text-dark">Réassigner l'Enseignant</h4>
                            <p className="text-muted small">Sélectionnez le nouveau titulaire pour ce cours</p>
                        </div>

                        <div className="form-outline mb-4">
                            <label className="form-label fw-bold small text-uppercase text-secondary mb-2" htmlFor="teacher-select">
                                Nom de l'Enseignant <span className="text-danger">*</span>
                            </label>
                            
                            <div className="input-group">
                                <span className="input-group-text bg-light border-end-0 rounded-start-3">
                                    <i className="bi bi-search text-muted"></i>
                                </span>
                                <select 
                                    className="form-select form-select-lg border-start-0 rounded-end-3 fs-6 shadow-none border-light-subtle" 
                                    id="teacher-select"
                                    value={my_enseignant} 
                                    onChange={(e)=>setMy_enseignant(e.target.value)}
                                >
                                    <option value="" disabled>Rechercher un membre du personnel...</option>
                                    {enseignants.map((ense) => (
                                        <option value={ense.my_enseignant} key={ense.my_enseignant}>
                                            👨‍🏫 {ense.nom_complet}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Bouton d'action stylisé */}
                        <div className="d-grid">
                            <button 
                                className="btn btn-success btn-lg fw-bold shadow-sm rounded-3 py-3 transition-all" 
                                onClick={confirmSave}
                                style={{ letterSpacing: '0.5px' }}
                            >
                                <i className="bi bi-check-circle-fill me-2"></i>
                                Appliquer la modification
                            </button>
                            <button className="btn btn-link btn-sm text-decoration-none text-muted mt-2" onClick={()=>navigate('/Cours')}>
                                Annuler l'opération
                            </button>
                        </div>
                    </div>
                </div>
                
                {/* Petit rappel de sécurité sous la carte */}
                <p className="text-center text-muted mt-4 small">
                    <i className="bi bi-shield-lock me-1"></i> 
                    Les modifications sont enregistrées en temps réel dans la base de données.
                </p>
            </div>
        </div>
    </div>
</>

 
    )
}
export default Update